import { Component, OnInit, ViewChild, TemplateRef, OnDestroy, AfterViewInit, ChangeDetectorRef } from '@angular/core';
import { TableColumn, TableRow, CommonTableService } from 'app/services/common-table.service';
// import { CommonFunctionService } from 'app/services/common-function.service';
import { CommonDatagridComponent } from 'app/components/common-datagrid/common-datagrid.component';
// import { LayerQcService } from 'app/services/layer-qc.service';
// import { ToastrService } from 'ngx-toastr';
import { MainDataService } from 'app/services/main-data.service';
// import { ActivityService } from 'app/services/activity.service';
import { Subscription } from 'rxjs';
import { AttrIndexService } from 'app/services/attr-index.service';
import { SchemaNote } from '../layer-complex/layer-complex.component';

@Component({
	selector: 'app-additional-error-my-layers',
	templateUrl: './additional-error-my-layers.component.html',
	styleUrls: ['./additional-error-my-layers.component.css']
})
export class AdditionalErrorMyLayersComponent implements OnInit, AfterViewInit, OnDestroy {

	@ViewChild('schemaTable', { static: false }) schemaTable: CommonDatagridComponent;
	//
	@ViewChild('cellTempl', { static: false }) cellTempl: TemplateRef<any>;
	@ViewChild('schemaErrorTempl', { static: false }) schemaErrorTempl: TemplateRef<any>;
	// Table fields Describtion tooltip
	@ViewChild('schemaTooltipTempl', { static: false }) schemaTooltipTempl: TemplateRef<any>;
	//

	// Schema Table
	columns_schema: TableColumn[] = [];
	rows_schema: TableRow[] = [];
	selectedRows_schema: any[];

	tooltipCol = 'tooltip';
	schemaQcColName: string;
	private standFieldColName: string;

	private data: any[]; // All schema data (i.e. not filtered) for the selected layer

	private schemaDataSub: Subscription;
	// private schemaFilterSub: Subscription;
		// // Layer Table
		// @ViewChild('layerTable') layerTable: CommonDatagridComponent;
		// columns_layer: TableColumn[] = [];
		// rows_layer: TableRow[] = [];
		// selectedRows_layer: any[];

	constructor(
		private cdRef: ChangeDetectorRef,
		// private toastr: ToastrService,
		// private activityService: ActivityService,
		// private commonService: CommonFunctionService,
		private attrIndexService: AttrIndexService,
		private tableService: CommonTableService,
		// private qcService: LayerQcService,
		private mainDataService: MainDataService
	) { }

	onSelectData_schema(e) {}


	// private filterData(data: any[]) {
	// 	const options = this.mainDataService.schemaFilterInfo.getValue().filterOptions;
	// 	const selectedOptions = options.filter(op => op.isSelected);
	// 	return data.filter(i => {
	// 	// TODO
	// 		return i
	// 	});
	// }
	private setSchemaTableData(data: any[]) {
		if (!data || !data.length) { return; }
		const columns = this.tableService.setColumnsFromRows(data);
		columns.forEach((c) => {
			// Replace hyphens with spaces in name
			c.name = c.name.replace(/_/g, ' ');
			// Convert to title case
			const strLowerCase = c.name.toLowerCase();
			const strArr = strLowerCase.split(' ');
			for (let i = 0; i < strArr.length; i++) {
				strArr[i] = strArr[i].charAt(0).toUpperCase() + strArr[i].substring(1).toLowerCase();
			}
			const str = strArr.join(' ');
			c.name = str;
			this.tableService.addFixedCellClass('cell-align-C', c);
			// Apply template
			if (c.prop === this.schemaQcColName) {
				c.cellTemplate = this.schemaErrorTempl;
			} else if (c.prop === this.standFieldColName) {
				c.cellTemplate = this.schemaTooltipTempl;
			} else {
				c.cellTemplate = this.cellTempl;
			}
		});
		const schemaQcCol = this.tableService.getColumnByProp(columns, this.schemaQcColName);
		if (schemaQcCol) {
			schemaQcCol.name = 'QC';
			schemaQcCol.width = 40;
			// Move column to front
			const idx = columns.indexOf(schemaQcCol);
			columns.splice(idx, 1);
			columns.unshift(schemaQcCol);
		}
		data.forEach((d) => {
			const schemaNotes: SchemaNote[] = d[this.schemaQcColName];
			d[this.tooltipCol] = this.mainDataService.getTooltipFromSchemaNotes(schemaNotes);
			// if (d[this.schemaQcColName] && d[this.schemaQcColName].length) {
			// 	d[this.schemaQcColName].toolTip = '';
			// 	d[this.schemaQcColName].forEach((n) => {
			// 		d[this.schemaQcColName].toolTip += n.msg;
			// 	});
			// }
		});
		this.columns_schema = columns;
		this.rows_schema = data;
	}
			// // Layer
			// private async getLayerData() {
			// 	this.layerTable.clearTableData();
			// 	try {
			// 		const rsp = await this.qcService.getQcLayerReport(this.myLayer.id);
			// 		this.setLayerTableData(rsp.data);
			// 	} catch (err) {
			// 		console.log(err);
			// 	}
			// 	this.commonService.setLoadingSpinner(false);
			// }
			// private setLayerTableData(data: any[]) {
			// 	if (!data || !data.length) { return; }
			// 	// Empty rows
			// 	const rows = [];
			// 	// Two fixed columns for qc layer report table
			// 	const itemCol = this.tableService.setNewColumn('layer_table_item', 'Item');
			// 	const valueCol = this.tableService.setNewColumn('layer_table_value', 'Value');
			// 	// itemCol.cellClass += 'cell-align-C ';
			// 	// valueCol.cellClass += 'cell-align-C';
			// 	// Transpose data
			// 	for (const prop of Object.keys(data[0])) {
			// 		const row = {
			// 			layer_table_item: prop,
			// 			layer_table_value: data[0][prop]
			// 		};
			// 		rows.push(row);
			// 	}
			// 	this.columns_layer = [itemCol, valueCol];
			// 	this.rows_layer = rows;
			// }
	ngOnInit() {
		this.schemaQcColName = this.attrIndexService.schemaNotesColName;
		this.standFieldColName = this.attrIndexService.standFieldColName;
		// this.schemaDataSub = this.mainDataService.schemaDataBS.subscribe(data => {
		// 	if (this.schemaTable) {
		// 		this.schemaTable.clearTableData();				
		// 	}
		// 	if (data) {
		// 		this.data = data.data;
		// 		// const filtered = this.filterData(this.data);
		// 		this.setSchemaTableData(this.data);
		// 	}
		// });
		// this.schemaFilterSub = this.mainDataService.schemaFilterInfo.subscribe(data => {
		// 	if (data) {
		// 		const filtered = this.filterData(this.data);
		// 		this.setSchemaTableData(filtered);
		// 	}
		// });
	}
	ngAfterViewInit(): void {
		this.schemaDataSub = this.mainDataService.schemaDataBS.subscribe(data => {
			if (this.schemaTable) {
				this.schemaTable.clearTableData();				
			}
			if (data) {
				this.data = data.data;
				// const filtered = this.filterData(this.data);
				this.setSchemaTableData(this.data);
				this.cdRef.detectChanges();
			}
		});
	}
	ngOnDestroy(): void {
		this.schemaDataSub.unsubscribe();
	}
}
